import { es, en, ptBr } from './locale';
import routes from './routes';

const PreAnaliseModule = {
    init: ({ i18n, router }) => {
        i18n.mergeLocaleMessage('pt-BR', {
            preanalise: {
                ...ptBr
            }
        });
        i18n.mergeLocaleMessage('en', {
            preanalise: {
                ...en
            }
        });
        i18n.mergeLocaleMessage('es', {
            preanalise: {
                ...es
            }
        });

        router.addRoutes(routes);
    }
};

export default PreAnaliseModule;
